import { render } from "./UIUCFooter.vue?vue&type=template&id=9ec72494&scoped=true"
import script from "./UIUCFooter.vue?vue&type=script&lang=js"
export * from "./UIUCFooter.vue?vue&type=script&lang=js"

import "./UIUCFooter.vue?vue&type=style&index=0&id=9ec72494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec72494"]])

export default __exports__